export default {"src":"/_next/static/media/partner27.2609bd3f.svg","height":70,"width":123,"blurWidth":0,"blurHeight":0};